import {t} from '@lingui/core/macro';

export type DomainCheckState = 'disabled' | 'unchecked' | 'ready';

export function getDomainCheckState(
    isWatched: boolean,
    value: string | boolean | null | undefined,
): DomainCheckState {
    if (!isWatched) {
        return 'disabled';
    }

    return value === null || value === undefined ? 'unchecked' : 'ready';
}

export function getDomainCheckPlaceholder(state: DomainCheckState): string {
    return state === 'disabled' ? t`Проверка выключена` : t`Ещё не проверялось`;
}
